import { useUser } from 'core/user/user';
import useLatest from 'utils/hooks/useLatest';

export const USER_ROLE = {
  viewer: 0,
  initiator: 1,
  manager: 2,
  admin: 3
};

export const USER_ROLE_LABEL = {
  [USER_ROLE.viewer]: 'Viewer',
  [USER_ROLE.initiator]: 'Initiator',
  [USER_ROLE.manager]: 'Manager',
  [USER_ROLE.admin]: 'Administrator'
};

export const useHasAccess = () => {
  const { user } = useUser();
  const roleRef = useLatest(user?.role ?? null);

  const hasAccess = (roleToAccess) => roleRef.current !== null && roleRef.current >= roleToAccess;

  return {
    hasAccess,
    hasEditAccess: () => hasAccess(USER_ROLE.initiator),
    hasAdminAccess: () => hasAccess(USER_ROLE.admin)
  };
};
